<template>
  <div class="third-party">
    <div class="third-party-main">
      <!-- <div class="info-box">
        <div class="info-item">
          <b>来源：</b>UVideo
        </div>
        <div class="info-item">
          <b>地区：</b>印度
        </div>
      </div>-->
      <div class="main-list">
        <div class="filter-box first">
          <div class="filter-list">
            <div class="filter-item">
              <b>来源：</b>
              <el-select
                @change="originChangHandle"
                v-model="origin"
                size="small"
                placeholder="请选择来源"
              >
                <el-option
                  v-for="(item, index) in originList"
                  :key="index"
                  :value="index"
                  :label="item"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="filter-box">
          <div class="filter-list">
            <div class="filter-item">
              <b>筛选条件：</b>
              <el-select
                v-model="sortCondition"
                size="small"
                placeholder="请选择排序条件"
                @change="conditionChangeHandle"
              >
                <el-option
                  v-for="(item, index) in conditionList"
                  :key="index"
                  :value="index"
                  :label="item"
                  >{{ item }}</el-option
                >
              </el-select>
            </div>
            <div class="filter-item">
              <b>创意类型：</b>
              <el-select
                v-model="type"
                size="small"
                placeholder="请选择创意类型"
                @change="search"
              >
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :value="index"
                  :label="item"
                  >{{ item }}</el-option
                >
              </el-select>
            </div>
            <div class="filter-item">
              <b>发布时间：</b>
              <el-date-picker
                v-model="publishTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                unlink-panels
                :picker-options="pickerOptions"
                @change="search"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </div>

          <div class="total-box">共有{{ total }}条搜索结果</div>
        </div>
        <waterfall
          :col="waterfallWidth"
          :width="216"
          :loadDistance="0"
          :gutterWidth="20"
          :data="dataList"
          :scrollObj="scrollObj"
          :wrapObj="'.third-party-main'"
          @loadmore="loadMore"
        >
          <template>
            <div
              class="image-item"
              v-for="(item, index) in dataList"
              :key="index"
              @click="reviewMaterial(item)"
            >
              <div class="image-box">
                <img v-if="!item.isPlay" :src="item.vodVideoThumbnail" alt />
                <!-- <ali-player
                  :path="'https://outin-47e1df49a3e311eaa4ef00163e1c94a4.oss-cn-shanghai.aliyuncs.com/a01f2cf9f9a8420290eb608b1c9b8f94/d413d58c4ce64602ab105234fd5b3f93-52817ef0d3b33dbf77e0a7c9e182cbfb-ld.mp4?Expires=1591687545&OSSAccessKeyId=LTAIVVfYx6D0HeL2&Signature=XestVseinhaYgVrExtfH%2FPiu8ys%3D'"
                  v-if="index === 0"
                ></ali-player>-->
                <video
                  v-if="item.isPlay"
                  controls
                  :src="item.ossPath"
                  autoplay
                />
                <img
                  v-if="!item.isPlay"
                  src="../../assets/images/video-play-icon.png"
                  alt
                  class="video-play"
                />
                <i
                  class="favor"
                  @click.stop="favorMaterial(item)"
                  :class="{ active: item.collectStatus }"
                ></i>
              </div>
              <!-- <h3 class="title">{{ item.kuaiShouId }}</h3> -->
              <div class="info">
                <div class="info-item">
                  <a>{{ item.likeCount || 0 }}</a>
                  <p>点赞</p>
                </div>
                <div class="info-item">
                  <a>{{ item.viewCount || 0 }}</a>
                  <p>展示</p>
                </div>
                <div class="info-item">
                  <a>{{ item.shareCount || 0 }}</a>
                  <p>分享</p>
                </div>
                <!-- <p>评论次数：{{ item.commentCount }}</p>
                <p>下载数：{{ item.downloadCount }}</p>-->
              </div>
              <div class="share">
                <!-- <div class="data-list">
                  <div class="data-item">
                    <i class="icon"></i>
                    <p>{{ item.shareCount || 0 }}</p>
                  </div>
                  <div class="data-item">
                    <i class="icon like"></i>
                    <p>{{ item.likeCount || 0 }}</p>
                  </div>
                  <div class="data-item">
                    <i class="icon view"></i>
                    <p>{{ item.viewCount || 0 }}</p>
                  </div>
                </div>-->

                <p class="time">{{ item.publishTime }}</p>
              </div>
            </div>
          </template>
        </waterfall>
        <div class="none" v-show="dataList.length === 0">
          <img src="../../assets/images/search-none.png" alt />
          <p>暂无搜索结果</p>
        </div>
        <div class="loading" v-show="isLoading && dataList.length !== 0">
          <i class="el-icon-loading"></i>
        </div>
      </div>
    </div>

    <third-party-review
      @close="closeReview"
      :item="currentItem"
      v-show="reviewShow"
    ></third-party-review>
  </div>
</template>
<script>
import ThirdPartyReview from "../../components/ReviewMaterial";
import AliPlayer from "../../components/AliPlayer";
import {
  getThirdPartyList,
  saveThirdPartyToMyDataBase,
  downloadThirdPartyFile,
  cancelFavor
} from "../../assets/js/api";
import { PromiseWidget } from "../../assets/js/tools";
export default {
  props: ["count"],
  components: { ThirdPartyReview, AliPlayer },
  data() {
    return {
      sortCondition: 0,
      conditionList: [
        "点赞次数",
        "播放次数",
        "下载次数",
        "评论次数",
        "分享次数"
      ],
      type: 0,
      typeList: ["视频"],
      publishTime: [],
      total: 0,
      waterfallWidth: 5,
      dataList: [],
      scrollObj: ".third-party",
      fullHeight: 0,
      currentPage: 1,
      reviewShow: false,
      currentItem: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "过去3天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "过去7天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "过去14天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "过去30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      isLoading: true,
      originList: ["UVideo（印度）", "VStatus（巴西）"],
      origin: ""
    };
  },
  watch: {
    reviewShow(val) {
      document.body.classList[val ? "add" : "remove"]("overflow");
      document
        .querySelector(".third-party")
        .classList[val ? "add" : "remove"]("overflow");
    }
  },
  created() {
    this.fullHeight = `${document.documentElement.offsetHeight - 60}px`;
    this.currentPage = 1;
    this.dataList = [];
  },
  mounted() {
    this.getThirdPartyList();
  },
  methods: {
    async downloadVideo(item) {
      const loading = this.$loading({
        lock: true,
        text: "唤起下载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const [err, data] = await PromiseWidget.to(
        downloadThirdPartyFile(item.kuaiShouId)
      );
      this.$nextTick(() => {
        loading.close();
      });
      if (data) {
        const objectURL = URL.createObjectURL(data);
        const aTag = document.createElement("a");
        aTag.href = objectURL;
        aTag.download = `${item.kuaiShouId}.mp4`;
        document.body.appendChild(aTag);
        aTag.click();
        aTag.remove();
      }
    },
    closeReview(item) {
      this.reviewShow = false;
    },
    reviewMaterial(item) {
      this.reviewShow = true;
      this.currentItem = item;
      console.log(item)
    },
    async favorMaterial(item) {
      let data = {},
        err = "";
      const loading = this.$loading({
        lock: true,
        text: item.collectStatus ? "正在取消收藏..." : "转存至个人素材库中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (item.collectStatus) {
        [err, data] = await PromiseWidget.to(cancelFavor([item.id]));
      } else {
        [err, data] = await PromiseWidget.to(
          saveThirdPartyToMyDataBase([item.id])
        );
      }

      this.$nextTick(() => {
        loading.close();
      });
      if (data.code === 200) {
        this.$message({
          showClose: true,
          message: item.collectStatus ? "取消收藏成功" : "收藏成功",
          type: "success"
        });
        item.collectStatus = !item.collectStatus;
      } else {
        this.$message({
          showClose: true,
          message: "操作失败:" + data.msg,
          type: "warning"
        });
      }
    },
    playVideo(item) {
      item.isPlay = true;
    },
    async getThirdPartyList() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: "加载中...",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
      document.querySelector(".third-party").classList.add("overflow");
      const [err, data] = await PromiseWidget.to(
        getThirdPartyList({
          page: this.currentPage,
          sortType: this.sortCondition,
          startDate:
            this.publishTime && this.publishTime.length === 2
              ? this.publishTime[0]
              : "",
          endDate:
            this.publishTime && this.publishTime.length === 2
              ? this.publishTime[1]
              : "",
          origin: this.origin
        })
      );
      this.$nextTick(() => {
        // loading.close();
        document.querySelector(".third-party").classList.remove("overflow");
      });
      if (data.code === 200) {
        this.isLoading = data.data.totalPage !== this.currentPage;
        data.data.rows.map(item => {
          item.publishTime = item.publishTime.substring(0, 10);
          item.commentCount =
            item.commentCount > 10000
              ? `${(item.commentCount / 10000).toFixed(0)}w`
              : item.commentCount;
          item.likeCount =
            item.likeCount > 10000
              ? `${(item.likeCount / 10000).toFixed(0)}w`
              : item.likeCount;
          item.viewCount =
            item.viewCount > 10000
              ? `${(item.viewCount / 10000).toFixed(0)}w`
              : item.viewCount;
          item.downloadCount =
            item.downloadCount > 10000
              ? `${(item.downloadCount / 10000).toFixed(0)}w`
              : item.downloadCount;
          item.shareCount =
            item.shareCount > 10000
              ? `${(item.shareCount / 10000).toFixed(0)}w`
              : item.shareCount;
          item.isPlay =
            typeof item.isPlay !== "undefined" ? item.isPlay : false;
        });
        this.dataList = this.dataList.concat(data.data.rows);
        this.total = data.data.totalSize;
      }
    },
    loadMore() {
      this.currentPage++;
      this.getThirdPartyList();
    },
    search() {
      this.currentPage = 1;
      this.dataList = [];
      this.getThirdPartyList();
    },
    originChangHandle(val) {
      const eventLabel = val ? "VStatus" : "UVideo";
      gtag("event", "select", {
        event_category: "source",
        event_label: eventLabel
      });
      this.search();
    },
    conditionChangeHandle(val) {
      const obj = {
        0: "number_likes",
        1: "number_play",
        2: "number_download",
        3: "number_comment",
        4: "number_share"
      };
      gtag('event', 'click', {
        'event_category' : 'select',
        'event_label' : obj[val]
      });
      this.search();
    }
  }
};
</script>
<style lang="scss" scoped>
.third-party {
  width: 100%;
  height: calc(100vh - 60px);
  overflow-y: auto;

  .none {
    padding: 100px 0;
  }

  .loading {
    padding-bottom: 20px;
  }

  &.overflow {
    overflow: hidden;
  }

  .third-party-main {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0 0;
  }
  .info-box {
    padding: 30px 0 30px;
    .info-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .main-list {
    background-color: #fff;
    padding: 14px 0 0;
    .filter-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px 20px;
      border-bottom: 1px solid #dcdfe6;
      margin-bottom: 20px;

      &.first {
        border-bottom: 0;
        margin-bottom: 0;

        .filter-list {
          width: 100%;
          padding-bottom: 14px;
          border-bottom: 1px dashed #dcdfe6;

          .filter-item {
            .el-select {
              width: 200px;
            }
          }
        }
      }

      .filter-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      .filter-item {
        margin-right: 20px;
        .el-select {
          width: 120px;
        }

        .total {
          color: #606266;
        }
      }
    }

    .image-item {
      background-color: #fff;
      box-shadow: 0px 3px 10px rgba(16, 72, 132, 0.15);
      margin-bottom: 24px;
      cursor: pointer;

      &:hover {
        background-color: #fff;
        box-shadow: 0px 6px 12px rgba(11, 75, 143, 0.2);
        transform: translateY(-1px);
        transition: all 0.5s;
      }

      h3.title {
        margin: 20px 0 10px;
        color: #303133;
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        padding: 0 20px;
      }

      .image-box {
        position: relative;

        i.favor {
          width: 40px;
          height: 40px;
          border-radius: 5px;
          background: url(../../assets/images/favor-hover-icon.png) no-repeat
            center center rgba(0, 0, 0, 0.5);
          position: absolute;
          right: 10px;
          top: 10px;
          display: none;

          &.active {
            background-image: url(../../assets/images/favor-active-icon.png);
          }
        }

        &:hover {
          i.favor {
            display: block;
          }
        }

        img,
        video {
          display: block;
          max-width: 100%;
          &.video-play {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate3d(-50%, -50%, 0);
            width: 50px;
            height: 50px;
          }
        }
        cursor: pointer;
      }

      .info {
        padding: 10px 20px;
        border-bottom: 1px solid #dcdfe6;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .info-item {
          a {
            color: #1983f9;
            font-size: 14px;
          }

          p {
            color: #909399;
            font-size: 12px;
            line-height: 16px;
          }
        }

        p {
          color: #909399;
          line-height: 1.25;
          font-size: 14px;
          margin: 0;
        }
        h3.title {
          padding: 0 16px;
          color: #303133;
          flex: 1;
          font-size: 14px;
          font-weight: 400;
          margin: 0;
          text-overflow: ellipsis;
          white-space: nowrapnowrap;
          overflow: hidden;
          text-align: left;
          p {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin: 0 0 0 8px;
            i {
              width: 20px;
              height: 20px;
              background: url(../../assets/images/file-size.png) no-repeat;
            }
          }
        }

        p.desc {
          color: #909399;
          margin-top: 10px;
          text-align: left;
          padding: 0 16px;
        }
        .label-list {
          display: flex;
          padding: 0 16px;
          justify-content: flex-start;
          align-items: center;
          margin-top: 20px;
          .label-item {
            padding: 0 8px;
            height: 22px;
            line-height: 22px;
            background-color: #f5f5f5;
            color: #606266;
            border: 1px solid rgba(217, 217, 217, 1);
            font-size: 12px;
            border-radius: 5px;
            margin-right: 10px;
          }
        }
      }

      .share {
        padding: 10px 16px;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .data-list {
          display: flex;
          justify-content: flex-start;
          align-content: center;
        }

        .data-item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-right: 5px;

          &:last-child {
            margin-right: 0;
          }
          i.icon {
            width: 20px;
            height: 20px;
            background: url(../../assets/images/share-icon.png) no-repeat;

            &.like {
              background: url(../../assets/images/like-icon.png) no-repeat;
            }
            &.view {
              background: url(../../assets/images/view-icon.png) no-repeat
                center center;
              margin-right: 2px;
            }
          }
          p {
            color: #606266;
            font-size: 12px;
            margin: 0;
            height: 20px;
            line-height: 20px;
          }
        }

        p {
          margin: 0;
          color: #c0c4cc;
        }

        // i {
        //   width: 20px;
        //   height: 20px;
        //   background: url(../../assets/images/google-icon.png) no-repeat;
        //   &.facebook {
        //     background: url(../../assets/images/facebook-icon.png) no-repeat;
        //   }
        // }

        // p {
        //   margin: 0;
        //   color: #c0c4cc;
        // }
      }
    }
  }
}
</style>
